module.exports = __webpack_public_path__ + "static/media/device_plus_app@2x.537e9a1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/device_plus_app@2x.png
// module id = 548
// module chunks = 0